module.exports = __webpack_public_path__ + "static/Design_Services-4d8915f7cff578f8e23d367cffa1a138.svg";